module.exports = __webpack_public_path__ + "static/img/1.82b9b6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/1.png
// module id = 9BaF
// module chunks = 19